import React from 'react';
import { Box, styled } from '@mui/material';

// Tarjeta de contador premium (sistema negro+dorado). Superficie elevada con hairline,
// inner-highlight y sombra teñida; en hover se levanta y enciende un borde dorado sutil
// (en vez del antiguo opacity). Curva cubic-bezier (soft-skill). Compartida por todos
// los dashboards, así que premium-iza los counters de cliente/trainer/admin a la vez.
const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

const StyledCounterContainer = styled(({ double, clickable, ...otherProps }) => <Box {...otherProps} />)(
  ({ double, clickable, theme }) => ({
    backgroundColor: theme.palette.surface.raised,
    border: `1px solid ${theme.palette.hairline.main}`,
    borderRadius: '14px',
    height: '100%',
    overflow: 'hidden',
    padding: double
      ? `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(2)}`
      : theme.spacing(1),
    position: 'relative',
    boxShadow: `inset 0 1px 0 ${theme.palette.innerHighlight}, ${theme.palette.shadow.card}`,
    transition: `transform 0.25s ${EASE}, box-shadow 0.25s ${EASE}, border-color 0.25s ${EASE}`,
    ...(clickable && {
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-3px)',
        backgroundColor: theme.palette.surface.hover,
        borderColor: theme.palette.hairline.strong,
        boxShadow: `inset 0 1px 0 ${theme.palette.innerHighlight}, ${theme.palette.shadow.card}`
      }
    }),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2)
    },
    [theme.breakpoints.up('md')]: {
      borderRadius: '16px'
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(3)
    }
  })
);

export default StyledCounterContainer;
